import React, { useEffect, useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { getSiteAnalytics } from '../../../services/manage'
import { ErrorBox } from '../../ErrorBox/ErrorBox'
import { addUpgradeReason } from 'utils/general'
import styles from './AnalyticsAll.module.css'

const AnalyticsAll = ({ domain, trialMode, onUpgradeCTA }) => {
  const [hasErrored, setHasErrored] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [siteAnalytics, setSiteAnalytics] = useState({})

  useEffect(() => {
    if (!trialMode) {
      fetchAnalyticsInfo()
    }
  }, [])

  const fetchAnalyticsInfo = async () => {
    setHasErrored(false)

    const domainValue = typeof domain === 'object' ? domain.subdomain : domain
    setIsLoading(true)
    try {
      const { data } = await getSiteAnalytics({ domain: domainValue })
      setSiteAnalytics(data)
      setIsLoading(false)
    } catch (error) {
      setHasErrored(true)
      setIsLoading(false)
    }
  }

  const handleUpgrade = () => {
    addUpgradeReason('View Analytics')
    onUpgradeCTA()
  }

  return (
    <>
      {isLoading && (
        <div className="text-center p-5">
          <Spinner animation="border" variant="primary" />
        </div>
      )}
      {!isLoading && trialMode && (
        <>
          <img src="/assets/img/gifs/analytics.gif" width="100%" alt="Analytics Preview" />
          <div className={`${styles.trialCTA} mt-2`}>
            <div className="bold">Access all of your metrics</div>
            <Button className="mt-md-0 mt-2" variant="purple" onClick={handleUpgrade}>
              Upgrade to unlock →
            </Button>
          </div>
        </>
      )}
      {!isLoading && !trialMode && siteAnalytics?.sharedLink?.url && (
        <iframe
          title="plausible-embed"
          /* eslint-disable-next-line react/no-unknown-property */
          plausible-embed="true"
          id="plausible-iframe"
          src={`${siteAnalytics.sharedLink.url}&embed=true&theme=light`}
          style={{ width: '100%', height: '600px', border: '0' }}
          allowFullScreen
        ></iframe>
      )}
      {!isLoading && hasErrored && <ErrorBox onClick={fetchAnalyticsInfo} />}
      {!isLoading && !trialMode && !siteAnalytics?.sharedLink?.url && !hasErrored && (
        <div className="text-center p-5 text-muted">Analytics data not available.</div>
      )}
    </>
  )
}

export default AnalyticsAll
